/* eslint-disable */
import {
	parseNumber,
	parsePhoneNumber as parsePhoneNumberLib,
	getCountryCallingCode
} from 'libphonenumber-js';

/**
 * @param {String} countryCode >> 3166 Alpha 2 Country Code. E.g. 'US'
 * @returns {String}           >> E.g. '1'
 */
export function getCountryCode(countryCode) {
	return getCountryCallingCode(countryCode);
}

/**
 * Removes unnecessary characters from phone number.
 * @param {String} phoneNumber
 */
function phoneNumberCleanser(phoneNumber) {
	const junk = ['(', ')', '-', '.', '/', '\\', ' '];
	let result = '';
	for (let i = 0; i < phoneNumber.length; i++) {
		if (!junk.includes(phoneNumber[i])) {
			result += phoneNumber[i];
		}
	}
	return result;
}

/**
 * Parses and returns valid phone number.
 * Assumes it's UK phone number if international code is not provided and number starts with "07".
 * @param {String} phoneNumber
 * @param {String} defaultCountry
 * @returns {Object}
 */
export function parsePhoneNumber(phoneNumber, defaultCountry = 'US') {
	// Clean phone number
	phoneNumber = phoneNumberCleanser(phoneNumber);

	// Remove "0" appearing after UK's country code.
	if (phoneNumber.startsWith('+4407')) {
		phoneNumber = phoneNumber.replace('+4407', '+447');
	}

	// Set default country if country code is not provided and it's a UK phone number.
	// https://textrecruit.atlassian.net/browse/CE-68
	if (phoneNumber.startsWith('07')) {
		defaultCountry = 'GB';
	}
	if (phoneNumber.startsWith('689')) {
		defaultCountry = 'US';
	}
	const parsedPhoneNumber = parseNumber(phoneNumber, { defaultCountry });
	return parsedPhoneNumber;
}

export function replaceSpecialChars(str, replaceStr = '') {
	return str.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, replaceStr);
}

export const formatPhoneNumber = (phoneNumber) => {
	const parsedData = {
		formattedPhoneNumber: '',
		ISO3166CountryCode: ''
	};
	if (!phoneNumber) {
		return parsedData;
	}
	// default to `US`
	const { nationalNumber, country = 'US' } = parsePhoneNumberLib(phoneNumber);
	parsedData.formattedPhoneNumber = nationalNumber;
	parsedData.ISO3166CountryCode = country;
	return parsedData;
};

/**
 * Function will return true if phone number belongs to a Canadian region; false otherwise
 * @param {Object} parsedPhoneNumberObject. Ex: {country: 'US', phone: '4085678899'}
 * @returns {boolean}
 */
export function isCanadianPhoneNumber(parsedPhoneNumberObject) {
	// Canadian area codes: https://www.allareacodes.com/canadian_area_codes.htm
	const ohCanada = [
		'204',
		'226',
		'236',
		'249',
		'250',
		'289',
		'306',
		'343',
		'365',
		'403',
		'416',
		'418',
		'431',
		'437',
		'438',
		'450',
		'506',
		'514',
		'519',
		'548',
		'579',
		'581',
		'587',
		'604',
		'613',
		'639',
		'647',
		'705',
		'709',
		'778',
		'780',
		'782',
		'807',
		'819',
		'825',
		'867',
		'873',
		'902',
		'905'
	];

	return (
		parsedPhoneNumberObject.country === 'US' &&
		// eslint-disable-next-line no-magic-numbers
		ohCanada.includes(parsedPhoneNumberObject.phone.slice(0, 3))
	);
}
